import { deserialize, serializable } from "serializr";
import { IJsonObject } from "../api";

interface IProps {
	totalTasks?: number;
	totalTasksOverdue?: number;
	totalTasksDueToday?: number;
	totalTimeLogged?: number;
}

export class ProjectStats {
	public static fromJson(json: IJsonObject): ProjectStats {
		return deserialize(ProjectStats, json);
	}

	@serializable
	public totalTasks: number;

	@serializable
	public totalTasksOverdue: number;

	@serializable
	public totalTasksDueToday: number;

	@serializable
	public totalTimeLogged: number;

	constructor({
		totalTasks = 0,
		totalTasksOverdue = 0,
		totalTasksDueToday = 0,
		totalTimeLogged = 0,
	}: IProps = {}) {
		this.totalTasks = totalTasks;
		this.totalTasksOverdue = totalTasksOverdue;
		this.totalTasksDueToday = totalTasksDueToday;
		this.totalTimeLogged = totalTimeLogged;
	}
}
